import { InventoryManager } from "@/pages/InventoryManager";

export default function StaffInventory() {
  return <InventoryManager scope="staff" />;
}
